import http, { API_PREFIX } from '../http'

export const uploadFileExemple = (formData, campaignId) =>
new Promise((resolve, reject) =>
    http({
      method: 'post',
      url: `${API_PREFIX}/campaigns/${campaignId}/import_csv`,
      data: formData,
      headers: {
        'content-type': `multipart/form-data; boundary=${formData._boundary}`
      }
    })
      .then(({ data }) => resolve(data))
      .catch(err => reject(err)))

export default { uploadFileExemple }

